<template>
      <div class="index container">

        <transition name="fade">
          <router-view @showParent="showParent">
          </router-view>
        </transition>
        
        <div v-if="showParentPage">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item
              :exact="true"
              :to="{ name: 'ruleVaccination', params: {} }"
              active
            >
              Rule Vaccination
            </v-breadcrumbs-item>
          </v-breadcrumbs>

        <div class="d-flex flex-column flex-lg-row">
          <v-text-field
            dense
            v-model="searchTerms"
            @keyup.enter="search"
            @click:clear="clearSearch"
            @click:append="search"
            placeholder="Press enter to begin search"
            append-icon="mdi-magnify"
            outlined
            clearable
            label="Search"
          />
          <v-btn
            class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
            color="primary"
            :to="{ name: 'ruleVaccinationCreate', params: {} }"
          >
            Create Rule Vaccination
          </v-btn>
        </div>

        <div class="table-container">
          <v-data-table
            :headers="headers"
            :items="ruleVaccinationList"
            :items-per-page="pagination.pageSize"
            :loading="!ruleVaccinationProcessed"
            :server-items-length="pagination.totalSize"
            :page="pagination.current"
            :disable-pagination="!ruleVaccinationList || ruleVaccinationList.length < 1"
            :hide-default-header="!ruleVaccinationList || ruleVaccinationList.length < 1"
            :hide-default-footer="!ruleVaccinationList || ruleVaccinationList.length < 1"
            :disable-sort="true"
            item-key="id"
            class="elevation-1"
            @update:options="pageChanged"
          >
            
            <template v-slot:item.minAge="{ item }">
              <a @click="view(item)">{{ item.minAge }}</a>
            </template>
            
            <template v-slot:item.doseCount="{ item }">
              <a @click="view(item)">{{ item.doseCount }}</a>
            </template>
            
            <template v-slot:item.timeBetweenDose="{ item }">
              <a @click="view(item)">{{ item.timeBetweenDose }}</a>
            </template>
            
            <template v-slot:item.timeBetweenDoseUnit="{ item }">
              <a @click="view(item)">{{ item.timeBetweenDoseUnit }}</a>
            </template>
            
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="edit(item)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="remove(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>
      <confirmation-dialog ref="confirm" />
    </div>
  </template>

    <script>
    import { mapActions, mapGetters } from "vuex";
    const ConfirmationDialog = () =>
    import("@/components/common/ConfirmationDialog.vue");
  
    export default {
      data(){
        return {
          pagination: {
            current: 1,
            pageSize: 10,
            totalSize: 100
          },
          ruleVaccinationList: [],
          showParentPage: true,
          
      headers: [
        {
          text: "Multiple Doses",
          value: "multipleDose",
          align: "start",
          sortable: false
        },
        {
          text: "Annually",
          value: "annually",
          align: "start",
          sortable: false
        },
        {
          text: "Start Age",
          value: "minAge",
          align: "start",
          sortable: false
        },
        {
          text: "Dose Count",
          value: "doseCount",
          align: "start",
          sortable: false
        },
        {
          text: "Time between Doses",
          value: "timeBetweenDose",
          align: "start",
          sortable: false
        },
        {
          text: "Time between Doses",
          value: "timeBetweenDoseUnit",
          align: "start",
          sortable: false
        },
        
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
          sort: {
            key: null
          },
          searchTerms : ''
        }
      },
      components: {
        ConfirmationDialog
      },
      computed: {
        ...mapGetters("ruleVaccination", ["ruleVaccinationProcessed", "getRuleVaccinations"]),
      },
      methods: {
        ...mapActions("messages", [
          "addErrorMessage",
          "addMessage",
          "addSuccessMessage"
        ]),
        ...mapActions("ruleVaccination", ["deleteRuleVaccination", "fetchRuleVaccinations"]),
        view(item){
          this.$router.push({ name: 'ruleVaccinationView', params: { id: item.id }})
        },
        edit(item){
          this.$router.push({ name: "ruleVaccinationEdit", params: { id: item.id }})
        },
        async remove(item){
          let confirm = await this.$refs.confirm.open(
            "Confirm Delete",
            "Do you want to delete this ruleVaccination?"
          );
          if(confirm){
            this.deleteRuleVaccination(item.id)
              .then( () => {
                this.addSuccessMessage("ruleVaccination was deleted successfully");
                this.getResources();
              }).catch( () => {
                this.addErrorMessage("Server response with error ");
              });
          }
        },
        getResources() {
          const params = {
            page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex-1:0,
            size: this.pagination.pageSize,
          };
          this.fetchRuleVaccinations(params)
            .then(response => {
              if(response){
                this.pagination.totalSize = response.totalElements;
                this.ruleVaccinationList = response.content;
              }
            })
            .catch(error => {
              this.addErrorMessage("Server response with error " + error);
            });
        },
        showParent(show) {
          this.showParentPage = show;
        },
        pageChanged(pagination) {
          this.pagination.pageIndex = pagination.page;
          this.pagination.pageSize = pagination.itemsPerPage;

          this.getResources()
        },
        search(){
          this.getResources();
        },
        clearSearch(){
          this.searchTerms = null;
          this.getResources();
        }
      },
      watch: {
        'pagination.numberRegisterForPage': function(){
            this.pagination.current = -1;
        },
      },
      beforeRouteUpdate(to, from, next) {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        this.showParentPage = toDepth < fromDepth;
        if (this.showParentPage) {
          this.getResources();
        }
        next();
      }
    }
    </script>

    